import request from "@/http/request";

import {
  getPlanList,
  getSessionList,
  judgeChange,
  getCourseList,
  getActivityList,
  queryPaperByCourseCode,
  addPaper,
  delPaper
} from '@/http/api';

export const delPaperApi = (data) => {
  return request({
      url: delPaper,
      data,
      methods: "GET"
  })
}

export const addPaperApi = (data) => {
  return request({
      url: addPaper,
      data,
      methods: "GET"
  })
}

export const queryPaperByCourseCodeApi = (data) => {
  return request({
      url: queryPaperByCourseCode,
      data,
      methods: "GET"
  })
}

export const getActivityListApi = (data) => {
  return request({
      url: getActivityList,
      data,
      methods: "GET"
  })
}

export const getCourseListApi = (data) => {
  return request({
      url: getCourseList,
      data,
      methods: "GET"
  })
}

export const getPlanListApi = (data) => {
    return request({
        url: getPlanList,
        data,
        methods: "GET"
    })
}

export const getSessionListApi = (data) => {
  return request({
      url: getSessionList,
      data,
  })
}

export const judgeChangeApi = (data) => {
  return request({
      url: judgeChange,
      data,
  })
}